
import { Link } from 'react-router-dom';
import { TechGrid, FloatingOrb } from '../../../components/base/FuturisticElements';

export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen relative overflow-hidden flex items-center justify-center">
      {/* Subtle Grid Background */}
      <TechGrid className="opacity-20" />
      
      {/* Floating Orb */}
      <FloatingOrb 
        className="top-1/4 right-1/4" 
        color="bg-blue-500/200/20"
      />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center max-w-4xl">
        {/* Minimalist Trust Badge */}
        <div className="inline-flex items-center gap-2 border border-blue-500/30 rounded-full px-4 py-1 mb-12">
          <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
          <span className="text-sm text-blue-300">
            Join Our Beta Program - Early Access Available
          </span>
        </div>

        {/* Clean Typography */}
        <h1 className="text-5xl md:text-6xl font-light mb-8 tracking-tight text-white">
          Stop Phishing
          <span className="inline-block ml-2 opacity-0 animate-fade-in-delayed">
            & Smishing
          </span>
          <br />
          <span className="text-blue-400 font-normal">Protect Your Business</span>
        </h1>
        
        <p className="text-xl mb-12 max-w-2xl mx-auto font-light text-gray-400">
          Revolutionary AI-powered cybersecurity designed for UK SMEs. 
          Currently in beta - join our early access program.
        </p>

     <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
        {/* Primary CTA */}
        <button
            onClick={() => window.open('https://nudge.driscop.co.uk/', '_blank')}
            className="group w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-medium transition-all duration-300 cursor-pointer bg-white text-black hover:bg-blue-600 hover:text-white"
        >
            Join Beta Program
            <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300 inline-block">→</span>
        </button>

        {/* Secondary CTA */}
        <Link
            to={'/check'}
            className="group inline-flex items-center justify-center w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-medium transition-all duration-300 cursor-pointer border-2 border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white"
        >
            Take Vulnerability check
            <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300 inline-block">→</span>
        </Link>
    </div>

        {/* Minimalist Problem Statement */}
        <div className="mt-24 max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-3">
            <div className="w-8 h-0.5 bg-red-400"></div>
            <p className="font-light text-gray-300">
              <span className="text-red-400 font-medium">65% of cyberattacks</span> target UK SMEs. 
              Don't become a statistic.
            </p>
            <div className="w-8 h-0.5 bg-red-400"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('stats')}
          className="text-white hover:text-blue-400 transition-colors duration-300 cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
